import { render, staticRenderFns } from "./CategoryConfig.vue?vue&type=template&id=11ad1f92"
import script from "./CategoryConfig.vue?vue&type=script&lang=js"
export * from "./CategoryConfig.vue?vue&type=script&lang=js"
import style0 from "./CategoryConfig.vue?vue&type=style&index=0&id=11ad1f92&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports